import { render, staticRenderFns } from "./QROrdine.vue?vue&type=template&id=b31cb890&"
import script from "./QROrdine.vue?vue&type=script&lang=js&"
export * from "./QROrdine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports